import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { LinkedStatus } from '@/services/StoreManagement/MasterStores/hooks/show/useStoreManagementMasterStoreShow';
import { StoreManagementMasterStoreService } from '@/services/StoreManagement/MasterStores/StoreManagementMasterStoreService';

export type StoreManagementMasterStoreUpdateLinkedStatusParams = {
  linked_status: LinkedStatus;
};

export const useStoreManagementMasterStoreUpdateLinkedStatus = async (
  id: number,
  params: StoreManagementMasterStoreUpdateLinkedStatusParams
): Promise<void> => {
  const storeManagementMasterStoreService =
    new StoreManagementMasterStoreService(getClient());
  try {
    return await storeManagementMasterStoreService.updateLinkedStatus(
      id,
      params
    );
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
